module.exports = __webpack_public_path__ + "img/delete-careers2.7d46f37f.png";